import {
    RenderPaymentMethodEvent,
    PaymentMethod,
} from '@/shared/checkout/altapay/useAltaPay';
import { Ref, ref } from 'vue';
import { PaymentProvider, usePaymentOptions } from '@/shared/checkout/usePaymentOptions';
import basketStore from '@/shared/checkout/basket/basket.store';

const selectedPaymentMethod = ref<string | undefined>();
const paymentMethodsContainer: Ref<HTMLElement|undefined> = ref();

export default function useAltaPayPaymentMethods() {
    const { setSelectedProvider } = usePaymentOptions();
    const renderPaymentMethodElement = (paymentMethod: PaymentMethod): HTMLElement => {
        const elem = document.createElement('div');
        elem.classList.add('c-checkbox');
        const innerHTML = `
            <input type="radio" id="${paymentMethod.id}" name="altapay_payment_method_radio" value="${paymentMethod.id}" class="c-checkbox__field">
            <label for="${paymentMethod.id}" class="c-checkbox__label-radio c-checkbox__label-radio--altapay">
                <img src="${paymentMethod.logoUrl}" alt="${paymentMethod.name}" class="payment-method-icon"/>
                <span>
                    ${paymentMethod.name}
                    ${paymentMethod.description && paymentMethod.description !== paymentMethod.name ? `
                        <span class="payment-method-description">
                            ${paymentMethod.description}
                        </span>
                    ` : ''}
                </span>
            </label>
        `;
        elem.innerHTML = innerHTML;
        return elem;
    };

    const renderPaymentMethods = ({ paymentMethod, onSelectPaymentMethodCallback }: RenderPaymentMethodEvent) => {
        const element = renderPaymentMethodElement(paymentMethod);
        element.onchange = () => {
            setSelectedProvider(PaymentProvider.AltaPay);
            setSelectedPaymentMethod(paymentMethod.id);
            basketStore.setSelectedPaymentMethod(paymentMethod.paymentMethodMetadata.terminalName);
            onSelectPaymentMethodCallback();
        };
        return element;
    };

    const setSelectedPaymentMethod = (id?: string) => {
        selectedPaymentMethod.value = id;
    };

    const clearSelectedPaymentMethod = () => {
        setSelectedPaymentMethod(undefined);
    };

    const setPaymentMethodsContainer = container => {
        paymentMethodsContainer.value = container;
    };

    return {
        selectedPaymentMethod,
        paymentMethodsContainer,
        setPaymentMethodsContainer,
        clearSelectedPaymentMethod,
        setSelectedPaymentMethod,
        renderPaymentMethods,
    };
}
